import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface SwapPaymentsYearlyFieldProps {}

export const SwapPaymentsYearlyField: React.FC<SwapPaymentsYearlyFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ swap_payments_yearly: number }>()

  return (
    <FormField
      name="swap_payments_yearly"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Swap Payments Per Year</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              {...register('swap_payments_yearly')}
              placeholder={'Enter the swap payments per year...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
